/* Caveau - ritocchi della scheda prodotto. File a parte, caricato solo nella scheda del profumo:
   - prodotto esaurito: al posto del bottone spento compare la richiesta su WhatsApp, anche nella barra fissa del telefono;
   - prodotto senza descrizione: non resta il titolo "La fragranza" con il solo nome;
   - rate Scalapay sotto il prezzo: si toglie lo spazio vuoto che il riquadro dell'app ha sopra e sotto;
   - al posto del pulsante "Acquista con Shop": PayPal e tutti i circuiti di pagamento attivi, sotto i bottoni. */
(() => {
  'use strict';
  if (window.__caveauPdp) return;
  window.__caveauPdp = true;

  const ROOT = '.caveau-product-layout';

  const setAttr = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  const setText = (element, value) => {
    if (element.textContent !== value) element.textContent = value;
  };
  const setHidden = (element, hidden) => {
    if (element.hidden !== hidden) element.hidden = hidden;
  };
  const setClass = (element, name, on) => {
    if (element.classList.contains(name) !== on) element.classList.toggle(name, on);
  };

  // Dal collegamento già presente nella scheda: la frase breve e l'invito ("Richiedilo su WhatsApp").
  const labelParts = (source) => {
    const strong = source.querySelector('strong');
    if (!strong) return { main: source.textContent.replace(/\s+/g, ' ').trim(), note: '' };
    const clone = source.cloneNode(true);
    clone.querySelector('strong').remove();
    return {
      main: strong.textContent.replace(/\s+/g, ' ').trim(),
      note: clone.textContent.replace(/\s+/g, ' ').trim().replace(/[.:]$/, '')
    };
  };

  const syncRequest = (root) => {
    const source = root.querySelector('[data-cv-request]');
    const button = root.querySelector('.main-product_atc-btn:not(.restock-alerts-notify-button)');
    if (!source || !button) return;

    const soldOut = button.disabled === true;
    const parts = labelParts(source);
    const href = source.getAttribute('href') || '';

    let main = root.querySelector('[data-cv-request-main]');
    if (!main) {
      main = document.createElement('a');
      main.className = 'cv-request-main';
      main.setAttribute('data-cv-request-main', '');
      main.target = '_blank';
      main.rel = 'noopener';
      main.hidden = true;
      main.appendChild(document.createElement('small'));
      main.appendChild(document.createElement('span'));
    }
    // Prima del bottone del tema (che da esaurito è ridotto a un punto): il posto subito dopo il bottone lo usa l'app
    // "Avvisami" (ReStock); se ce lo contendiamo, le due parti si spostano a vicenda all'infinito.
    if (main.nextElementSibling !== button) button.insertAdjacentElement('beforebegin', main);
    setAttr(main, 'href', href);
    setText(main.querySelector('small'), parts.note);
    setText(main.querySelector('span'), parts.main);
    setHidden(main, !soldOut);
    setClass(root, 'cv-is-soldout', soldOut);

    const bar = document.querySelector('[data-cv-sticky-bar]');
    if (!bar) return;
    let link = bar.querySelector('[data-cv-sticky-request]');
    if (!link) {
      link = document.createElement('a');
      link.className = 'cv-sticky__request';
      link.setAttribute('data-cv-sticky-request', '');
      link.target = '_blank';
      link.rel = 'noopener';
      link.hidden = true;
      bar.appendChild(link);
    }
    setAttr(link, 'href', href);
    setText(link, parts.main);
    setHidden(link, !soldOut);
    setClass(bar, 'cv-sticky--request', soldOut);
  };

  const hideEmptyDescription = (root) => {
    root.querySelectorAll('.main-product_row--content:not(.cv-draft-description)').forEach((row) => {
      if (row.dataset.cvChecked) return;
      row.dataset.cvChecked = '1';
      const clone = row.cloneNode(true);
      clone.querySelectorAll('.cv-description-title, style, script').forEach((node) => node.remove());
      if (clone.textContent.replace(/\s+/g, ' ').trim().length < 120) row.classList.add('cv-empty');
    });
  };

  // Il componente di Scalapay ha spazio vuoto sopra e sotto il suo riquadro (circa 16 px, non modificabile dal tema).
  // Si misura dove inizia e finisce la parte visibile (bordo, sfondo, testo, logo) e si compensano i margini della riga
  // (vedi .cv-sp-fit nel CSS). Se il riquadro non mostra nulla (importo fuori soglia, paese non servito), la riga resta
  // con i margini normali.
  const fitScalapay = (root) => {
    const widget = root.querySelector('.main-product_widget scalapay-widget');
    const row = widget && widget.closest('.main-product_row');
    if (!row) return;
    if (!widget.dataset.cvFitWatch && 'ResizeObserver' in window) {
      widget.dataset.cvFitWatch = '1';
      new ResizeObserver(() => fitScalapay(root)).observe(widget);
    }
    const host = widget.getBoundingClientRect();
    const shadow = widget.shadowRoot;
    let top = Infinity;
    let bottom = -Infinity;
    if (shadow && host.height >= 1) {
      shadow.querySelectorAll('*').forEach((element) => {
        const tag = element.tagName.toLowerCase();
        if (tag === 'style' || tag === 'script') return;
        if (element.parentElement && element.parentElement.closest('svg, button')) return;
        const leaf = tag === 'svg' || tag === 'img' || tag === 'button' || (element.children.length === 0 && element.textContent.trim() !== '');
        const style = window.getComputedStyle(element);
        const painted = ['Top', 'Right', 'Bottom', 'Left'].some((side) => parseFloat(style['border' + side + 'Width']) > 0 && style['border' + side + 'Style'] !== 'none')
          || (style.backgroundColor !== 'rgba(0, 0, 0, 0)' && style.backgroundColor !== 'transparent')
          || style.boxShadow !== 'none';
        if (!leaf && !painted) return;
        const rect = element.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        top = Math.min(top, rect.top);
        bottom = Math.max(bottom, rect.bottom);
      });
    }
    if (top === Infinity) {
      setClass(row, 'cv-sp-fit', false);
      return;
    }
    const insetTop = Math.max(0, Math.round(top - host.top)) + 'px';
    const insetBottom = Math.max(0, Math.round(host.bottom - bottom)) + 'px';
    if (row.style.getPropertyValue('--cv-sp-top') !== insetTop) row.style.setProperty('--cv-sp-top', insetTop);
    if (row.style.getPropertyValue('--cv-sp-bottom') !== insetBottom) row.style.setProperty('--cv-sp-bottom', insetBottom);
    setClass(row, 'cv-sp-fit', true);
  };

  // PayPal e circuiti di pagamento: il riquadro arriva dal <template> di snippets/caveau-payments.liquid
  // e va subito dopo il gruppo dei bottoni d'acquisto (dopo "Richiedilo su WhatsApp" e "Avvisami" quando il prodotto è esaurito).
  const placePayments = (root) => {
    const template = root.querySelector('template[data-cv-payments-template]');
    const buttons = root.querySelector('.main-product_widget .main-product_form-btns');
    if (!template || !buttons) return;
    let block = root.querySelector('[data-cv-payments]');
    if (!block) {
      const source = template.content.querySelector('[data-cv-payments]');
      if (!source) return;
      block = source.cloneNode(true);
    }
    if (buttons.nextElementSibling !== block) buttons.insertAdjacentElement('afterend', block);
  };

  const run = () => {
    const root = document.querySelector(ROOT);
    if (!root) return;
    hideEmptyDescription(root);
    syncRequest(root);
    fitScalapay(root);
    placePayments(root);
  };

  const init = () => {
    const root = document.querySelector(ROOT);
    if (!root) return;
    run();
    if (root.dataset.cvPdpWatch) return;
    root.dataset.cvPdpWatch = '1';
    // Controllo di riserva per il riquadro Scalapay, che compare qualche istante dopo il caricamento.
    window.setTimeout(run, 1500);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.setTimeout(() => { queued = false; run(); }, 60);
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'href', 'amount'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
